var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_426_3197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_426_3197",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 15
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.17041 0.5H18.1704V14.9H0.17041V0.5Z",
    fill: "#4C525B"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_426_3197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.30541 3.438C2.31647 3.32821 2.30159 3.21736 2.26199 3.11436C2.22239 3.01137 2.15917 2.9191 2.07741 2.845L0.39741 0.805V0.5H5.61641L9.64941 9.415L13.1954 0.5H18.1704V0.805L16.7334 2.193C16.6724 2.24004 16.6254 2.30273 16.5972 2.3744C16.569 2.44607 16.5608 2.52403 16.5734 2.6V12.8C16.561 12.8758 16.5693 12.9536 16.5975 13.025C16.6256 13.0965 16.6726 13.159 16.7334 13.206L18.1364 14.595V14.899H11.0774V14.595L12.5324 13.171C12.6744 13.029 12.6744 12.986 12.6744 12.766V4.522L8.63241 14.867H8.08641L3.38041 4.522V11.455C3.36111 11.5985 3.37447 11.7446 3.41949 11.8822C3.4645 12.0199 3.54002 12.1456 3.64041 12.25L5.53141 14.562V14.867H0.17041V14.562L2.06041 12.25C2.16042 12.1458 2.23467 12.0196 2.27721 11.8816C2.31975 11.7435 2.32941 11.5974 2.30541 11.455V3.438Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_426_3197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 15,
    fill: "white",
    transform: "translate(0.17041 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/Medium.8b3bfad62bbe79203d5a0185894c20fb.svg";
export { ForwardRef as ReactComponent };